import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
//components
import ErrorMsg from '../ErrorMsg/ErrorMsg';
//css
import "./SearchResultPage.css";
//assets
import successLogo from '../../assets/complete.png';
import incompleteLogo from '../../assets/incomplete.png';
import ImageComponent from '../../helpers/ImageComponent';
//helpers
import { getSymbolFromCurrency } from '../../config/currencyConfig';
import { getPaymentIcon, showAmount } from '../../config/paymentConfig';
import Loader from '../../helpers/Loader';
import ToolTip from '../../helpers/ToolTip';

export default function SearchResultPage() {
    const SEARCH_URL = process.env.REACT_APP_SEARCH_URL;
    const navigate = useNavigate();
    const location = useLocation();
    const { transactions, authToken } = location.state || [];

    const transactionLength = transactions?.length;

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [startIndex, setStartIndex] = useState(1);
    const [endIndex, setEndIndex] = useState(transactionLength > 10 ? 10 : transactionLength);

    if (!transactions || transactions === null) {
        navigate("/")
    }
    const getDate = (epochTime) => {
        var options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true, timeZone: 'UTC' };
        var d = new Date(epochTime * 1000);
        d = d.toLocaleString("en-US", options).replace(" at", ",");
        return d;
    }

    const handleBackButtonClick = (e) => {
        e.preventDefault();
        navigate("/");
    }

    const handleItemClick = async (e, token) => {
        e.preventDefault();
        setErrorMessage("");
        if (token) {
            setIsLoading(true);
            try {
                let config = {
                    headers: { 'Authorization': `Bearer ${authToken}` }
                }
                await axios.get(`${SEARCH_URL}/${token}`, config).then(
                    (res) => {
                        navigate("/timeline-view", { state: { paymentInfo: res.data, transactions: transactions, authToken: authToken } });
                    })
            }
            catch (e) {
                console.error(e);
                setErrorMessage(`${e.response.data.message}! Please Try Again.`);
            }
            finally {
                setIsLoading(false);
            }
        }
        else {
            setErrorMessage("More information on this payment transaction is not available.");
        }
    }

    useEffect(() => {
        errorMessage && window.scrollTo({ top: 0, left: 0, behavior: "smooth", })
    }, [errorMessage])

    const resultPageClassName = isLoading ? 'search-result-page loader-enabled' : 'search-result-page';

    //pagination
    const pageCount = Math.ceil(transactionLength / 10); //10 items per page
    const currentItems = transactions?.slice(currentPage * 10, (currentPage + 1) * 10);
    const handlePageClick = (e) => {
        setCurrentPage(e.selected);
    }

    useEffect(() => {
        const endPage = (currentPage + 1) * 10;
        setStartIndex(currentPage === 0 ? 1 : (currentPage * 10 + 1));
        setEndIndex(endPage < transactionLength ? endPage : transactionLength);
    }, [currentPage])

    return (
        <>
            {isLoading && <Loader />}
            {errorMessage && <div className='error-container'><ErrorMsg errorMsg={errorMessage} /></div>}
            <div className={resultPageClassName}>
                <p className='result-text'>{`Showing ${startIndex} to ${endIndex} of ${transactionLength} Results`} </p>
                <div className='table-container'>
                    <table className='result-table'>
                        <thead>
                            <tr className='result-header'>
                                <th className='result-header-item amount'>Amount</th>
                                <th className='result-header-item'>Token Number</th>
                                <th className='result-header-item'>Status</th>
                                <th className='result-header-item'>Payment Type</th>
                                <th className='result-header-item'>Operation Type</th>
                                <th className='result-header-item'>Last Updated Date/Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems?.map((transaction, index) => {
                                const isDisabled = transaction.token?.startsWith("T");
                                return (
                                    <tr
                                        key={index}
                                        className={`table-row result-item-container${isDisabled ? " disabled-row" : ""}`}
                                        onClick={isDisabled ? undefined : (e) => handleItemClick(e, transaction.token)}
                                    >
                                        <td className='table-item amount'>
                                            {showAmount(transaction.amount) && (<span>{`${getSymbolFromCurrency(transaction.currency)} ${transaction.amount}`}</span>)}
                                        </td>
                                        <td className='table-item token-number'>{transaction.token}</td>
                                        <td className='table-item status'>
                                            {transaction.status === "SUCCESS" ? (
                                                <span className='success-status'>
                                                    Succeeded
                                                    <ImageComponent sourceUrl={successLogo} details="successIcon" width="9px" height="9px" />
                                                </span>
                                            ) : (
                                                <>
                                                    <span className='incomplete-status'>
                                                        Incomplete
                                                        <ImageComponent sourceUrl={incompleteLogo} details="incompleteIcon" width="9px" height="9px" />
                                                    </span>
                                                    {transaction.merchantResponse && transaction.merchantResponse !== "succeeded" && <ToolTip content={transaction.merchantResponse} />}
                                                </>
                                            )}
                                        </td>
                                        <td className='table-item payment-type-container'>
                                            <span className='payment-type'>
                                                {transaction.paymentMethod}
                                                {getPaymentIcon(transaction.paymentMethod)}
                                            </span>
                                        </td>
                                        <td className='table-item transaction-operation-type'>
                                            {transaction.operation}
                                        </td>
                                        <td className='table-item'>{getDate(transaction.transactionDate)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    {pageCount > 1 && <ReactPaginate
                        pageRangeDisplayed={2}
                        pageCount={pageCount}
                        marginPagesDisplayed={1}
                        onPageChange={handlePageClick}
                        previousLabel='< prev'
                        nextLabel='next >'
                        breakLabel="..."
                        pageClassName="page-item"
                        previousClassName="page-item"
                        nextClassName="page-item"
                        breakClassName="page-item"
                        containerClassName="pagination"
                        activeClassName="active-page-item"
                        disabledClassName="disabled-page-item"
                        renderOnZeroPageCount={null}
                    />}
                </div>
                <div className='back-button-container'>
                    <button className='back-button' onClick={handleBackButtonClick}>Back</button>
                </div>
            </div>
        </>
    )
}
